import { CSSProperties } from 'react';

export const CREATE_AUDIT_RECORD_BUTTON_LABEL = 'Create Audit Record';
export const CREATE_AUDIT_RECORD_HELPER_TEXT = 'For changes made outside of the Admin Console';

export const auditHelperTextStyle: CSSProperties = {
    fontStyle: 'italic',
    opacity: 0.7,
    marginLeft: 15,
};
